import _ from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { goBack, push } from 'react-router-redux'

import { clearFile, setFile } from '../actions/file'
import { clearProjectErrors, createProject, setProjectErrors } from '../actions/project'
import { clearUserKey, listUsers, setUserIsLoading, setUserSelected } from '../actions/user'

import ProjectAdd from '../components/ProjectAdd'

class ProjectAddPage extends Component {
  componentDidMount () {
    const { clearProjectErrors, clearFile, clearUserKey } = this.props
    clearProjectErrors()
    clearFile('project-add')
    clearFile('project-add-data')
    clearUserKey('collaborator')
    clearUserKey('adminCollaborator')
  }

  render () {
    return (<ProjectAdd {...this.props}/>)
  }
}

const mapStateToProps = (state, ownProps) => ({
  errors: state.project.errors || {},
  image: state.file['project-add'],
  imageData: state.file['project-add-data'],
  collaborator: state.user.collaborator || {
    isLoading: false,
    list: { rows: [] },
    selected: state.auth ? [_.pick(state.auth, ['id', 'name'])] : [],
    defaultSelected: state.auth ? [_.pick(state.auth, ['id', 'name'])] : []
  },
  adminCollaborator: state.user.adminCollaborator || { isLoading: false, list: { rows: [] }, selected: [] },
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  async onSubmit (values, image, collaborators, adminCollaborators) {
    const errors = {}
    if (!values.name) {
      errors.name = 'Name is required.'
    }
    if (values.description.length > 500) {
      errors.description = 'Description should not longer that 500 characters.'
    }
    if (!collaborators || _.isEmpty(collaborators)) {
      errors.collaborator = 'Collaborator is required.'
    }
    if (!adminCollaborators || _.isEmpty(adminCollaborators)) {
      errors.adminCollaborator = 'Admin Collaborator is required.'
    }
    if (!_.isEmpty(errors)) {
      dispatch(setProjectErrors(errors))
      return
    }
    dispatch(clearProjectErrors())
    await dispatch(createProject({
      ...values,
      image,
      collaborators: collaborators ?
        _.map(collaborators, (collaborator) => collaborator.id) : [],
      adminCollaborators: adminCollaborators ?
        _.map(adminCollaborators, (adminCollaborator) => adminCollaborator.id) : [],
    }))
    dispatch(push('/project'))
  },
  clearProjectErrors () {
    dispatch(clearProjectErrors())
  },
  uploadImage (event) {
    const file = event.target.files[0]
    dispatch(setFile('project-add', file))
    const reader = new FileReader()
    reader.onloadend = (event) => {
      dispatch(setFile('project-add-data', event.target.result))
    }
    reader.readAsDataURL(file)
  },
  clearFile (key) {
    dispatch(clearFile(key))
  },
  async searchUser (name, notUsers, key) {
    const notIds = notUsers.length > 0 ? _.map(notUsers, user => user.id) : undefined
    dispatch(setUserIsLoading(true, key))
    await dispatch(listUsers({ name, notIds }, key))
    dispatch(setUserIsLoading(false, key))
  },
  setUserSelected (selected, key) {
    dispatch(setUserSelected(selected, key))
  },
  clearUserKey (key) {
    dispatch(clearUserKey(key))
  },
  goBack () {
    dispatch(goBack())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ProjectAddPage)


// WEBPACK FOOTER //
// ./src/containers/ProjectAddPage.js